import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, React } from 'react';
import { Utils } from '../../Utils';

import AppHeader from "../../components/AppHeader/AppHeader.js";
import AppFooterMenu from "../../components/AppFooterMenu/AppFooterMenu.js";
import PopupOffline from '../../components/PopupOffline/PopupOffline';
import PopupContent from '../../components/PopupContent/PopupContent';

import PopupAddedToCart from '../../components/PopupAddedToCart/PopupAddedToCart';
import ShoppingCart from "../../components/ShoppingCart/ShoppingCart";
import CheckoutSummary from "../../components/CheckoutSummary/CheckoutSummary";
import CheckoutBill from "../../components/CheckoutBill/CheckoutBill";
import CheckoutDelivery from "../../components/CheckoutDelivery/CheckoutDelivery";
import CheckoutPayment from "../../components/CheckoutPayment/CheckoutPayment";
import ProductsMenu from "../../components/ProductsMenu/ProductsMenu.js";
import ProfileMenu from "../../components/ProfileMenu/ProfileMenu.js";
import MyOrders from "../../components/MyOrders/MyOrders.js";
import MyMessages from "../../components/MyMessages/MyMessages.js";
import RoyaltyCard from "../../components/RoyaltyCard/RoyaltyCard.js";
import Wishlist from "../../components/Wishlist/Wishlist.js";
import AppDiscounts from "../../components/AppDiscounts/AppDiscounts.js";
import Profile from "../../components/Profile/Profile.js";
import Shops from "../../components/Shops/Shops.js";
//import ProfilePaymentMethod from "../../components/ProfilePaymentMethod/ProfilePaymentMethod.js";
import ProfileBillAddress from "../../components/ProfileBillAddress/ProfileBillAddress.js";
import ProfileDeliveryAddresses from "../../components/ProfileDeliveryAddresses/ProfileDeliveryAddresses.js";

const Layout = (props) => {

  const navigate = useNavigate();

  // A useEffect egy React Hook, amely lehetővé teszi az összetevők külső rendszerrel való szinkronizálását.
  useEffect(() => {

    // data-type nélküli linkek (azok aamelyek nem areacttal lettek előállítva) lekezelése
    // target="_blank" url-el csak akkor enged ablakot nyitni ha a href-ben szerepel a ://

    window.onclick = function (e) {
     
      if (e.target.localName === 'a' && !e.target.dataset.type) 
      {
        let href = e.target.getAttribute('href');
        let target = e.target.getAttribute('target');
        let popup = e.target.getAttribute('data-popup');

        if (parseInt(popup) === 1 && href.indexOf('://') === -1)
        {
          e.preventDefault(); 

          Utils.get_server_data(
            '/content/' + href, 
            {ajax_event: 'content', APICACHE: 'false'}, 
            {}
          ).then(res => {
            window.modals.PopupContentRef.current.show(res);
          }); 
          
        }
        else if (!target || href.indexOf('://') === -1)
        {
          e.preventDefault(); 

          Utils.get_url_data(href).then(res => {
            navigate('/' + res.url_type + '/' + href);
          });
        }
      }
    }
      
  }, []); 

  return (<> 
      <AppHeader ref={window.AppHeaderRef} />
      {window.AppRef.current.is_online() ? '' : <PopupOffline />}
      <Outlet />

      <PopupContent ref={window.modals.PopupContentRef} />
      <PopupAddedToCart ref={window.modals.PopupAddedToCartRef} />
      <ShoppingCart ref={window.modals.ShoppingCartRef} />
      <ProductsMenu ref={window.modals.ProductsMenuRef} />
      <ProfileMenu ref={window.modals.ProfileMenuRef} />
      <AppDiscounts ref={window.modals.AppDiscountsRef} />
      <AppDiscounts ref={window.modals.AppDiscountsRef_2} />
      <Shops ref={window.modals.ShopsRef} />

      {window.AppRef.current.get_is_signed() ? <>
        <CheckoutSummary ref={window.modals.CheckoutSummaryRef} />
        <CheckoutBill ref={window.modals.CheckoutBillRef} />
        <CheckoutDelivery ref={window.modals.CheckoutDeliveryRef} />
        <CheckoutPayment ref={window.modals.CheckoutPaymentRef} />
        <MyOrders ref={window.modals.MyOrdersRef} />
        <MyOrders ref={window.modals.MyOrdersRef_2} />
        <MyMessages ref={window.modals.MyMessagesRef} />
        <MyMessages ref={window.modals.MyMessagesRef_2} />
        <Wishlist ref={window.modals.WishlistRef} />
        <RoyaltyCard ref={window.modals.RoyaltyCardRef} />
        <Profile ref={window.modals.ProfileRef} />
        {/*<ProfilePaymentMethod ref={window.modals.ProfilePaymentMethodRef} />*/}
        <ProfileBillAddress ref={window.modals.ProfileBillAddressRef} />
        <ProfileDeliveryAddresses ref={window.modals.ProfileDeliveryAddressesRef} />
      </> : ''}

      <AppFooterMenu ref={window.AppFooterMenuRef} />
    </>)
};

export default Layout;